import { z } from 'zod';

/** The Leaving tab's termination date and time (PersonLeaving.tsx). */
export const dateSchema = z.object({
  /** yyyy-mm-dd from <input type="date">, '' = no date. */
  TerminationDate: z.string().regex(/^(\d{4}-\d{2}-\d{2})?$/, 'Not a valid date'),
  /**
   * hh:mm from <input type="time">, '' = no time (offboarding then acts at 20:00 that
   * day). Team walk-through 26/10/2026: OnsiteLive took a time for same-day leavers.
   */
  TerminationTime: z.string().regex(/^(\d{2}:\d{2})?$/, 'Not a valid time'),
})
  .refine((d) => !d.TerminationTime || !!d.TerminationDate, { message: 'Pick the date too', path: ['TerminationTime'] })
  // Midnight is how a date with no time is stored, so offboarding would read it as 20:00.
  .refine((d) => d.TerminationTime !== '00:00', { message: 'Midnight means "end of day" (20:00) - leave the time blank, or pick 00:01', path: ['TerminationTime'] });

/** The date and time to save: the date alone when no time is given (midnight = end of day). */
export function terminationValue(date: string, time: string): string {
  return time ? `${date}T${time}:00` : date;
}
